module.exports = __webpack_public_path__ + "img/roundedarw.ead5bccb.svg";